import React, { Component } from 'react';
import { tableStandarIndicators } from './Tables';
import $ from 'jquery';

class GenericTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows: 0,
            total: 0
        };
    }

    componentDidMount() {
        this.createDataTable();
    }

    componentDidUpdate(prevProps) {

        if (this.props.data !== prevProps.data) {
            if (this.table) {
                this.table.destroy();
                this.table = null;
            }
            this.createDataTable();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.data !== nextProps.data) {
            this.table.destroy();
            this.table = null;
        }
        return true;
    }

    createDataTable = () => {
        const { idTable = 'dataTableTimbra' } = this.props;
        this.table = $(`#${idTable}`).DataTable({
            "dom": '<"toolbar">rti',
            "pagingType": "full_numbers",
            "paging": true,
            "searching": true,
            "info": false,
            "columnDefs": [{
                "targets": 0,
                "orderable": false
            }],
            responsive: true,
        });

        this.getTableInfoResult();
        this.changePaging();
    };

    getTableInfoResult = () => {
        const { idTable = 'dataTableTimbra' } = this.props;
        const info = this.table.page.info();
        let num = 0;

        try {
            if (info && info.recordsDisplay !== 0) num = 1;
            // Actualiza el estado con los valores de filas y total
            this.setState({
                rows: info.end - info.start,
                total: info.recordsTotal
            });
        } catch (error) {
            console.log(error);
        }

        $(`#tableInfo${idTable}`).text((info.start + num) + " - " + info.end + " de " + info.recordsTotal);
        $('.dataTables_empty').text("No hay resultados por mostrar");
    }

    renderTable = () => {
        const { headers, data, view, action, weeks, idTable, checkBox, actionLabel, viewTools } = this.props;
        let table = '';
        switch (view) {
            case 'suggestRefillDoc':
                table = tableStandarIndicators(headers, data, view, action, idTable, actionLabel, viewTools);
                break;
            case 'searchPartnerRefSys':
                table = tableStandarIndicators(headers, data, view, action, idTable, actionLabel);
                break;
            case 'referredPartners':
                table = tableStandarIndicators(headers, data, view, action);
                break;
            case 'requestAmbassadors':
                table = tableStandarIndicators(headers, data, view, action);
                break;
            case 'referSystemAdmin':
                table = tableStandarIndicators(headers, data, view, action);
                break;
            case 'ambassadors':
                table = tableStandarIndicators(headers, data, view, action);
                break;
            case 'notiRefT1':
                table = tableStandarIndicators(headers, data, view, action, idTable);
                break
            case 'notiRefT2':
                table = tableStandarIndicators(headers, data, view, action, idTable);
                break;
            default:
                break;
        }

        return table;
    }

    changePaging = (value) => {
        const { idTable = 'dataTableTimbra' } = this.props;

        this.table.page.len(value ?? 10).draw();
        this.getTableInfoResult();
    }

    changePage = (page) => {
        if (this.table) {
            this.table.page(page).draw('page');
            this.getTableInfoResult();
        }
    }

    SearchInTable = key => {
        let value = key.target.value;
        this.table.search(value);
        this.table.draw();

        this.getTableInfoResult();
    }


    render() {
        const { enableSearchInTable = false, idTable = 'dataTableTimbra' } = this.props
        return (
            <>
                {enableSearchInTable &&
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-3 col-xl-3 mb-3 ml-auto">
                            <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc mr-sm-2'
                                placeholder="Buscar en tabla"
                                autoComplete="off"
                                id={`searchData${idTable}`}
                                type='search'
                                aria-controls={idTable}
                                onChange={(event) => this.SearchInTable(event)}
                            />
                        </div>
                    </div>
                }

                <div className="w-100 table-scroll">
                    {this.renderTable()}
                </div>
                <div className="col-12 mt-3">
                    <div className="d-flex flex-wrap justify-content-end align-items-center">
                        <div className="form-group mb-2">
                            <label htmlFor="colFormLabelSm" className="col col-form-label col-form-label-sm text-right registros" style={{ width: 195 }}>
                                Registros por página:
                            </label>
                        </div>
                        <div className="form-group mb-2">
                            <select
                                className="col col-form-label col-form-label-sm text-right"
                                style={{ width: 80 }}
                                aria-controls={idTable}
                                id={`changePaginateSelect${idTable}`}
                                // disabled
                                onChange={(event) => this.changePaging(event.target.value)}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>&nbsp;&nbsp;
                        </div>
                        <div className="form-group mb-2">

                            <label htmlFor="colFormLabelSm" id={`tableInfo${idTable}`}
                                className="col-form-label col-form-label-sm">
                            </label>

                            {/* <label htmlFor="colFormLabelSm"
                                className="col-form-label col-form-label-sm">
                                {rows} de {total}
                            </label> */}
                        </div>
                    <div className="d-flex align-items-center mb-2 flex-nowrap">
                        <button className="btn btn-link btn-sm " style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Primera" onClick={() => this.changePage('first')}
                        >
                            <i className="fas fa-chevron-left btn-first" />
                        </button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Anterior" onClick={() => this.changePage('previous')}
                        >
                            <i className="fas fa-chevron-left" />
                        </button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Siguiente" onClick={() => this.changePage('next')}
                        >
                            <i className="fas fa-chevron-right" />
                        </button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Última" onClick={() => this.changePage('last')}
                        >
                            <i className="fas fa-chevron-right btn-last" />
                        </button>
                    </div>
                    </div>
                </div>
            </>
        );
    }
}

export default GenericTable;
